import {Modal, Button, Spinner, Form} from 'react-bootstrap'
import {useEffect, useState, useMemo} from 'react'
import {toast} from 'react-toastify'
import {useLazyQuery, useMutation} from '@apollo/client'
import {
  IPipelineGroupsPipeline,
  IPipelineMembersPipeline,
  IResAllListUsers,
  IRespAddGroupPipeline,
  IRespAddUserPipeline,
  IRespDelGroupPipeline,
  IRespDelUserPipeline,
} from '../../../types/users'
import {GET_ALL_USERS_LIST} from '../../../gql/queries/usersQuery'
import {GET_GROUPS_PIPELINE, GET_MEMBERS_PIPELINE} from '../../../gql/queries/pipelines'
import {ADD_USER_TO_PIPELINE, REMOVE_USER_TO_PIPELINE} from '../../../gql/mutations/userMutations'
import {DragDropContext, Draggable, Droppable, DropResult} from 'react-beautiful-dnd'
import {parseId} from '../../../helpers'
import Lottie from 'lottie-react'
import noLeads from '../../../assets/lotties/no-leads.json'

import {
  ADD_GROUP_TO_PIPELINE,
  REMOVE_GROUP_TO_PIPELINE,
} from '../../../gql/mutations/pipelineMutations'
import {IResGroups} from '../../../types/assignmentGroups'
import {GET_ALL_GROUPS} from '../../../gql/queries/asiignmentGruopQuery'

interface ModalAssignAgentsToPipelineProps {
  isOpen: boolean
  onClose: () => void
  info: {
    pipelineName: string
    pipelineId: string
  }
  typeAssign: string
}

export const ModalAssignAgentsToPipeline = ({
  isOpen,
  onClose,
  info,
  typeAssign,
}: ModalAssignAgentsToPipelineProps) => {
  const [userUpdates, setUserUpdates] = useState(0)
  const [searchAvailable, setSearchAvailable] = useState('')
  const [searchAssigned, setSearchAssigned] = useState('')

  // Limpiar filtros cuando se cierra el modal
  useEffect(() => {
    if (!isOpen) {
      setSearchAvailable('')
      setSearchAssigned('')
    }
  }, [isOpen])

  const [
    gqlGetMembersPipeline,
    {data: dataMembersPipeline, loading: loadingMemberPipelin, error: errorMembersPipline},
  ] = useLazyQuery<IPipelineMembersPipeline>(GET_MEMBERS_PIPELINE, {fetchPolicy: 'no-cache'})

  const [
    gqlGetGroupsPipeline,
    {data: dataGroupPipeline, loading: loadingGroupPipelin, error: errorGroupPipeline},
  ] = useLazyQuery<IPipelineGroupsPipeline>(GET_GROUPS_PIPELINE, {fetchPolicy: 'no-cache'})

  const [gqlAllMembers, {data: allMembers, loading: loadingMember, error: errorMembers}] =
    useLazyQuery<IResAllListUsers>(GET_ALL_USERS_LIST, {
      fetchPolicy: 'no-cache',
    })

  const [gqlAllGroups, {data: allGroups, loading: loadingGroups, error: errorGroups}] =
    useLazyQuery<IResGroups>(GET_ALL_GROUPS, {
      fetchPolicy: 'no-cache',
    })

  const [
    gqlAddMembers,
    {data: addUserToPipeline, loading: loadingAddUserToPipeline, error: errorAddUserToPipeline},
  ] = useMutation<IRespAddUserPipeline>(ADD_USER_TO_PIPELINE)
  const [
    gqlDelMembers,
    {data: delUserToPipeline, loading: loadingDelUserToPipeline, error: errorDelUserToPipeline},
  ] = useMutation<IRespDelUserPipeline>(REMOVE_USER_TO_PIPELINE)

  const [
    gqlAddGroup,
    {data: addGroupToPipeline, loading: loadinAddGroupToPipeline, error: errorAddGroupToPipeline},
  ] = useMutation<IRespAddGroupPipeline>(ADD_GROUP_TO_PIPELINE)
  const [
    gqlDelGroup,
    {data: delGroupToPipeline, loading: loadinDelGroupToPipeline, error: errorDelGroupToPipeline},
  ] = useMutation<IRespDelGroupPipeline>(REMOVE_GROUP_TO_PIPELINE)

  useEffect(() => {
    if (typeAssign === 'user') {
      gqlGetMembersPipeline({
        variables: {
          id: parseId(info.pipelineId),
        },
      })
    }
    if (typeAssign === 'group') {
      gqlGetGroupsPipeline({
        variables: {
          id: parseId(info.pipelineId),
        },
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gqlGetGroupsPipeline, gqlGetMembersPipeline, info, userUpdates])

  useEffect(() => {
    if (typeAssign === 'user') {
      gqlAllMembers()
    }
    if (typeAssign === 'group') {
      gqlAllGroups()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gqlAllGroups, gqlAllMembers, userUpdates])

  // useEffect(() => {
  //   if (errorAddUserToPipeline) toast.error(`Error: ${errorAddUserToPipeline.message}`)
  //   if (errorDelUserToPipeline) toast.error(`Error: ${errorDelUserToPipeline.message}`)

  //   if (errorAddGroupToPipeline) toast.error(`Error: ${errorAddGroupToPipeline.message}`)
  //   if (errorDelGroupToPipeline) toast.error(`Error: ${errorDelGroupToPipeline.message}`)

  //   if (errorMembers) toast.error(`Error: ${errorMembers.message}`)
  //   if (errorGroups) toast.error(`Error: ${errorGroups.message}`)

  //   if (errorMembersPipline) toast.error(`Error: ${errorMembersPipline.message}`)
  //   if (errorGroupPipeline) toast.error(`Error: ${errorGroupPipeline.message}`)
  // }, [
  //   errorAddUserToPipeline,
  //   errorDelUserToPipeline,
  //   errorMembersPipline,
  //   errorMembers,
  //   errorAddGroupToPipeline,
  //   errorDelGroupToPipeline,
  //   errorGroups,
  //   errorGroupPipeline,
  // ])

  // useEffect(() => {
  //   if (typeAssign === 'user') {
  //     console.log(JSON.stringify(addUserToPipeline));
  //     console.log(JSON.stringify(delUserToPipeline));

  //     if (!addUserToPipeline && !delUserToPipeline) return
  //     if (addUserToPipeline?.addUserToPipeline?.success) {
  //       toast.success('User assgined to pipeline successfully')
  //       setUserUpdates((p) => p + 1)
  //     } else if (delUserToPipeline?.removeUserFromPipeline?.success) {
  //       toast.success('User removed to pipeline successfully')
  //       setUserUpdates((p) => p + 1)
  //     } else {
  //       toast.error(
  //         `Error: ${addUserToPipeline?.addUserToPipeline?.errors} ${delUserToPipeline?.removeUserFromPipeline?.errors}`
  //       )
  //     }

  //   }
  //   if (typeAssign === 'group') {
  //     if (!addGroupToPipeline && !delGroupToPipeline) return
  //     if (addGroupToPipeline?.addGroupToPipeline?.success) {
  //       toast.success('Group assgined to pipeline successfully')
  //       setUserUpdates((p) => p + 1)
  //     } else if (delGroupToPipeline?.removeGroupFromPipeline?.success) {
  //       toast.success('Group removed to pipeline successfully')
  //       setUserUpdates((p) => p + 1)
  //     } else {
  //       toast.error(
  //         `Error: ${addGroupToPipeline?.addGroupToPipeline?.errors} ${delGroupToPipeline?.removeGroupFromPipeline?.errors}`
  //       )
  //     }
  //   }
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [delUserToPipeline, addUserToPipeline, addGroupToPipeline, delGroupToPipeline])

  const handleMutationFeedback = (
    data: any,
    path: string[],
    successMsg: string,
    errorMsgPrefix: string,
    onSuccess?: () => void
  ) => {
    // Profundiza en el objeto: data.addUserToPipeline.success → ['addUserToPipeline', 'success']
    const result = path.reduce((acc, key) => (acc ? acc[key] : null), data)

    if (result?.success) {
      toast.success(successMsg)
      onSuccess?.()
    } else {
      const errors = result?.errors || 'Unknown error'
      toast.error(`${errorMsgPrefix}: ${errors}`)
    }
  }
  useEffect(() => {
    if (typeAssign !== 'user' || !addUserToPipeline) return

    handleMutationFeedback(
      addUserToPipeline,
      ['addUserToPipeline'],
      'User assigned to pipeline successfully',
      'Error assigning user',
      () => setUserUpdates((p) => p + 1)
    )
  }, [addUserToPipeline, typeAssign])
  useEffect(() => {
    if (typeAssign !== 'user' || !delUserToPipeline) return

    handleMutationFeedback(
      delUserToPipeline,
      ['removeUserFromPipeline'],
      'User removed from pipeline successfully',
      'Error removing user',
      () => setUserUpdates((p) => p + 1)
    )
  }, [delUserToPipeline, typeAssign])
  useEffect(() => {
    if (typeAssign !== 'group' || !addGroupToPipeline) return

    handleMutationFeedback(
      addGroupToPipeline,
      ['addGroupToPipeline'],
      'Group assigned to pipeline successfully',
      'Error assigning group',
      () => setUserUpdates((p) => p + 1)
    )
  }, [addGroupToPipeline, typeAssign])
  useEffect(() => {
    if (typeAssign !== 'group' || !delGroupToPipeline) return

    handleMutationFeedback(
      delGroupToPipeline,
      ['removeGroupFromPipeline'],
      'Group removed from pipeline successfully',
      'Error removing group',
      () => setUserUpdates((p) => p + 1)
    )
  }, [delGroupToPipeline, typeAssign])

  const handleApolloError = (error: any, context?: string) => {
    if (!error) return

    const msg = error.message || 'Unknown error'
    const fullMessage = context ? `${context}: ${msg}` : `Error: ${msg}`

    console.error('[ApolloError]', context, error)
    toast.error(fullMessage)
  }

  useEffect(() => {
    handleApolloError(errorAddUserToPipeline, 'Error adding user to pipeline')
    handleApolloError(errorDelUserToPipeline, 'Error removing user from pipeline')
    handleApolloError(errorAddGroupToPipeline, 'Error adding group to pipeline')
    handleApolloError(errorDelGroupToPipeline, 'Error removing group from pipeline')
    handleApolloError(errorMembers, 'Error fetching members')
    handleApolloError(errorGroups, 'Error fetching groups')
    handleApolloError(errorMembersPipline, 'Error fetching members from pipeline')
    handleApolloError(errorGroupPipeline, 'Error fetching groups from pipeline')
  }, [
    errorAddUserToPipeline,
    errorDelUserToPipeline,
    errorAddGroupToPipeline,
    errorDelGroupToPipeline,
    errorMembers,
    errorGroups,
    errorMembersPipline,
    errorGroupPipeline,
  ])

  // Función de filtrado para usuarios disponibles
  const filteredAvailableUsers = useMemo(() => {
    if (typeAssign !== 'user' || !allMembers?.allUsersList) return []

    const searchLower = searchAvailable.toLowerCase()
    // Crear un Set con los IDs parseados de los usuarios asignados
    const assignedUserIds = new Set(
      dataMembersPipeline?.pipelineById?.users?.edges?.map((edge) => parseId(edge.node.id)) || []
    )

    const available = allMembers.allUsersList
      .filter((u) => !assignedUserIds.has(parseId(u.id)))
      .filter((node) => {
        const fullName = `${node.firstName} ${node.lastName}`.toLowerCase()
        return fullName.includes(searchLower) || node.email.toLowerCase().includes(searchLower)
      })

    return available
  }, [typeAssign, allMembers, dataMembersPipeline, searchAvailable])

  // Función de filtrado para grupos disponibles
  const filteredAvailableGroups = useMemo(() => {
    if (typeAssign !== 'group' || !allGroups?.allGroupAssignments.edges) return []

    const searchLower = searchAvailable.toLowerCase()
    // Crear un Set con los IDs parseados de los grupos asignados
    const assignedGroupIds = new Set(
      dataGroupPipeline?.pipelineById?.groups?.edges?.map((edge) => parseId(edge.node.id)) || []
    )

    return allGroups.allGroupAssignments.edges
      .filter(({node}) => !assignedGroupIds.has(parseId(node.id)))
      .filter(({node}) => node.name.toLowerCase().includes(searchLower))
  }, [typeAssign, allGroups, dataGroupPipeline, searchAvailable])

  // Función de filtrado para usuarios asignados
  const filteredAssignedUsers = useMemo(() => {
    if (typeAssign !== 'user' || !dataMembersPipeline?.pipelineById?.users?.edges) return []

    const searchLower = searchAssigned.toLowerCase()

    return dataMembersPipeline.pipelineById.users.edges
      .filter(({node}) => {
        const fullName = `${node.firstName} ${node.lastName}`.toLowerCase()
        return fullName.includes(searchLower) || node.email.toLowerCase().includes(searchLower)
      })
      .sort((a, b) => {
        const nameA = `${a.node.firstName} ${a.node.lastName}`.toLowerCase()
        const nameB = `${b.node.firstName} ${b.node.lastName}`.toLowerCase()
        return nameA.localeCompare(nameB)
      })
  }, [typeAssign, dataMembersPipeline, searchAssigned])

  // Función de filtrado para grupos asignados
  const filteredAssignedGroups = useMemo(() => {
    if (typeAssign !== 'group' || !dataGroupPipeline?.pipelineById?.groups?.edges) return []

    const searchLower = searchAssigned.toLowerCase()

    return dataGroupPipeline.pipelineById.groups.edges
      .filter(({node}) => node.name.toLowerCase().includes(searchLower))
      .sort((a, b) => a.node.name.toLowerCase().localeCompare(b.node.name.toLowerCase()))
  }, [typeAssign, dataGroupPipeline, searchAssigned])

  const handleAssignPipelines = async (result: DropResult) => {
    const {source, destination, draggableId} = result

    // Cancelado o no cambió de lista
    if (!destination || source.droppableId === destination.droppableId) {
      return
    }

    try {
      if (source.droppableId === 'disponibles' && destination.droppableId === 'conPermiso') {
        // Agregar permiso
        if (typeAssign === 'user') {
          const result = await gqlAddMembers({
            variables: {
              userId: parseId(draggableId),
              pipelineId: parseId(info.pipelineId),
            },
          })
          if (result.data?.addUserToPipeline?.success) {
            // Refrescar las listas
            setUserUpdates((p) => p + 1)
          }
        }
        if (typeAssign === 'group') {
          const result = await gqlAddGroup({
            variables: {
              groupId: parseId(draggableId),
              pipelineId: parseId(info.pipelineId),
            },
          })
          if (result.data?.addGroupToPipeline?.success) {
            // Refrescar las listas
            setUserUpdates((p) => p + 1)
          }
        }
      } else if (source.droppableId === 'conPermiso' && destination.droppableId === 'disponibles') {
        // Quitar permiso
        if (typeAssign === 'user') {
          const result = await gqlDelMembers({
            variables: {
              userId: parseId(draggableId),
              pipelineId: parseId(info.pipelineId),
            },
          })
          if (result.data?.removeUserFromPipeline?.success) {
            // Refrescar las listas
            setUserUpdates((p) => p + 1)
          }
        }
        if (typeAssign === 'group') {
          const result = await gqlDelGroup({
            variables: {
              groupId: parseId(draggableId),
              pipelineId: parseId(info.pipelineId),
            },
          })
          if (result.data?.removeGroupFromPipeline?.success) {
            // Refrescar las listas
            setUserUpdates((p) => p + 1)
          }
        }
      }
    } catch (error) {
      console.error('Error en la mutación de drag & drop:', error)
    }
  }

  return (
    <Modal show={isOpen} onHide={onClose} size='xl'>
      <Modal.Header closeButton>
        <Modal.Title>
          {typeAssign === 'user' && 'Assign revisor agent to pipeline '}
          {typeAssign === 'group' && 'Assign group to pipeline '}
          <span className='fw-bold text-uppercase'>{info.pipelineName}</span>{' '}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='d-flex justify-content-start h-100 flex-column'>
          {/* <h2 className='fs-1'>Management revisor agents to pipeline: {info.pipelineName}</h2> */}
          {typeAssign === 'user' && <h2>The assigned agents can view all leads on the pipeline</h2>}
          {typeAssign === 'group' && (
            <h2>The assigned groups can view all leads on the pipeline</h2>
          )}
          <div className='d-flex w-100 flex-row '>
            <DragDropContext onDragEnd={handleAssignPipelines}>
              <Droppable droppableId='disponibles'>
                {(provided) => (
                  <div className='list-user-available w-50 p-3 border border-secondary rounded'>
                    {typeAssign === 'user' && <div className='title'>Agents available</div>}
                    {typeAssign === 'group' && <div className='title'>Groups available</div>}
                    {(loadingMember ||
                      loadingGroups ||
                      loadingAddUserToPipeline ||
                      loadingDelUserToPipeline ||
                      loadinAddGroupToPipeline ||
                      loadinDelGroupToPipeline) && (
                      <span>
                        <Spinner animation='border' size='sm' />
                      </span>
                    )}
                    <Form.Control
                      type='text'
                      placeholder='Search by name or email...'
                      value={searchAvailable}
                      onChange={(e) => setSearchAvailable(e.target.value)}
                      className='mb-3'
                    />
                    <div
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                      style={{maxHeight: typeAssign === 'user' ? 400 : 250}}
                    >
                      <div
                        style={{
                          maxHeight: typeAssign === 'user' ? '400px' : '250px',
                          overflowY: 'auto',
                        }}
                      >
                        {typeAssign === 'user' &&
                          filteredAvailableUsers.map((node, index) => (
                            <Draggable key={node.id} draggableId={node.id} index={index}>
                              {(provided) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  className='user-available'
                                >
                                  {node.firstName} {node.lastName} - {node.email}
                                </div>
                              )}
                            </Draggable>
                          ))}
                        {typeAssign === 'group' &&
                          filteredAvailableGroups.map(({node}, index) => (
                            <Draggable key={node.id} draggableId={node.id} index={index}>
                              {(provided) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  className='user-available'
                                >
                                  {node.name}
                                </div>
                              )}
                            </Draggable>
                          ))}

                        {provided.placeholder}
                      </div>
                    </div>
                  </div>
                )}
              </Droppable>
              <Droppable droppableId='conPermiso'>
                {(provided) => (
                  <div className='list-user-assigned h-400 w-50 p-3 border border-secondary rounded'>
                    {typeAssign === 'user' && (
                      <div className='title'>Agents assigned to pipeline</div>
                    )}
                    {typeAssign === 'group' && (
                      <div className='title'>Groups assigned to pipeline</div>
                    )}
                    {(loadingMemberPipelin ||
                      loadingGroupPipelin ||
                      loadingAddUserToPipeline ||
                      loadingDelUserToPipeline ||
                      loadinAddGroupToPipeline ||
                      loadinDelGroupToPipeline) && (
                      <span>
                        <Spinner animation='border' size='sm' />
                      </span>
                    )}
                    <Form.Control
                      type='text'
                      placeholder='Search by name or email...'
                      value={searchAssigned}
                      onChange={(e) => setSearchAssigned(e.target.value)}
                      className='mb-3'
                    />
                    <div
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                      style={{maxHeight: typeAssign === 'user' ? 400 : 300}}
                    >
                      <div
                        style={{
                          maxHeight: typeAssign === 'user' ? '400px' : '300px',
                          overflowY: 'auto',
                        }}
                      >
                        {((typeAssign === 'user' && filteredAssignedUsers.length === 0) ||
                          (typeAssign === 'group' && filteredAssignedGroups.length === 0)) && (
                          <div className='d-flex align-items-center justify-content-center w-100'>
                            <div style={{maxWidth: '200px'}}>
                              <Lottie
                                animationData={noLeads}
                                autoPlay
                                style={{maxWidth: '200px'}}
                              />
                            </div>
                          </div>
                        )}
                        {typeAssign === 'user' &&
                          filteredAssignedUsers.map(({node}, index) => (
                            <Draggable key={node.id} draggableId={node.id} index={index}>
                              {(provided) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  className='user-available'
                                >
                                  {node.firstName} {node.lastName} - {node.email}
                                </div>
                              )}
                            </Draggable>
                          ))}
                        {typeAssign === 'group' &&
                          filteredAssignedGroups.map(({node}, index) => (
                            <Draggable key={node.id} draggableId={node.id} index={index}>
                              {(provided) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  className='user-available'
                                >
                                  {node.name}
                                </div>
                              )}
                            </Draggable>
                          ))}

                        {provided.placeholder}
                      </div>
                    </div>
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </div>
          {!loadingMember && allMembers && <div></div>}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose} variant='secondary'>
          Close
        </Button>
        {/* <Button
          onClick={handleAssignPipelines}
          variant='primary'
          disabled={loadingMemberPipelin || loadingMember || valueUser === ''}
        >
          {loadingMemberPipelin || loadingMember && <Spinner animation='border' className='me-2' size='sm' />}
          <i className='bi bi-person-up' />
          Assign
        </Button> */}
      </Modal.Footer>
    </Modal>
  )
}
